<template>
  <div class="topDiv" style>
    <el-row class="mainContent" style="height: 100%;">
      <el-col :span="24" class="sreachInputMargin">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
          <el-select v-model="select" slot="prepend" placeholder="不限职位" style="color:#000">
            <el-option
              v-for="(item,index) in allCity"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-input>
      </el-col>
      <el-col :span="2" class="sreachButton">搜索</el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      menuIndex: 3,
      sreachValue: "",
      input3: "",
      select: "",
      allCity: this.$store.state.sys_dicts.allCity,
      selectPostion: [
        { label: "全部职位", value: "all" },
        { label: "运营", value: "在职-考虑机会" },
        { label: "当前已发布的所有职位归属", value: "在职-月内到岗" },
      ],
    };
  },
  methods: {
    changeClass(index) {
      this.menuIndex = index;
      //加载不同类型残疾人数据
    },
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  background-color: #F0F2F5;
  margin: 0 auto;

  .sreachInputMargin {
    width: 600px;
  }

  >>>.el-input-group__append, >>>.el-input-group__prepend {
    background-color: #F5F7FA;
    color: #000;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 0 20px;
    width: 100px;
    white-space: nowrap;

    input::-webkit-input-placeholder {
      color: #000;
    }

    input::-moz-input-placeholder {
      color: #000;
    }

    input::-ms-input-placeholder {
      color: #000;
    }
  }

  >>>.el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #fff;
    box-sizing: border-box;
    color: #000;
    display: inline-block;
    font-size: inherit;
    height: 50px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }

  >>>.input-with-select {
    border: 1px solid #fff;
    border-radius: 6px;
    outline: none;
  }

  .sreachButton {
    width: 140px;
    height: 50px;
    background: #f82b18;
    line-height: 50px;
    text-align: center;
    margin-top: 11px;
    color: #fff;
  }

  .mainContent {
    padding: 0px 40px 0px 0px;
    height: 100%;
    position: relative;
    font-size: 18px;
    line-height: 64px;
    text-align: left;
  }
}
</style>